export const CheckBox = ({ register, ...props }) => (
  <input type="checkbox" {...register} {...props} />
);
